'use client';
import { useEffect, useRef, useState } from 'react';
import './index.scss';
import classNames from 'classnames';

export interface EfVideoMediaProps {
    /**
     * 所有分辨率展示的视频链接
     */
    pc: string;
    /**
     * 视频链接-分辨率小于等于1024px
     */
    h5?: string;
    /**
     * 视频贴图-所有分辨率
     */
    poster?: string;
    /**
     * 视频贴图-分辨率小于等于1024px
     */
    posterH5?: string;
    /**
     * 是否自动播放
     */
    autoPlay?: boolean;
    /**
     * 是否循环播放
     */
    loop?: boolean;
    /**
     * 样式名
     */
    className?: string;
}

/**
 * 用于播放视频
 *
 * 视频右上角会有个播放按钮,在不播放时展示
 */
export default function EfVideoMedia({ className = '', autoPlay, loop = false, poster, pc, pad, h5 }: EfVideoMediaProps) {
    const prefixCls = 'ef-video-media';
    const compCls = classNames(prefixCls, {
        [`${className}`]: className,
    });
    const videoRef1 = useRef(null);
    const videoRef2 = useRef(null);
    const [showPlayIcon, setShowPlayIcon] = useState(!autoPlay);
    const [isPlay, setIsPlay] = useState(false);
    // 获取选中的元素
    const getShowVideo = () => {
        const videoA: any = videoRef1?.current;
        const videoB: any = videoRef2?.current;
        const blockA = videoA && window.getComputedStyle(videoA).display;
        const blockB = videoB && window.getComputedStyle(videoB).display;
        if (blockA === 'block') {
            return videoRef1;
        }
        if (blockB === 'block') {
            return videoRef2;
        }

        return null;
    };
    // 点击播放
    const playHandle = () => {
        setIsPlay(true);
        const videoA: any = getShowVideo()?.current;

        if (videoA) {
            videoA.play();
            setIsPlay(true);
            setShowPlayIcon(false);
        }
    };
    useEffect(() => {
        const videoA: any = getShowVideo()?.current;

        if (videoA) {
            videoA.addEventListener('ended', () => {
                setIsPlay(false);
                setShowPlayIcon(true);
            });
        }
    }, []);
    return (
        <div className={compCls}>
            {pc && (
                <video ref={videoRef1} playsInline muted autoPlay={autoPlay} loop={loop} poster={poster} className={`${prefixCls}-pc`}>
                    <source src={pc} />
                </video>
            )}
            {pad && (
                <video ref={videoRef2} playsInline muted autoPlay={autoPlay} loop={loop} poster={poster} className={`${prefixCls}-pad`}>
                    <source src={pad} />
                </video>
            )}
            {h5 && (
                <video ref={videoRef2} playsInline muted autoPlay={autoPlay} loop={loop} poster={poster} className={`${prefixCls}-h5`}>
                    <source src={h5} />
                </video>
            )}
            {showPlayIcon && !isPlay && (
                <svg
                    className={`${prefixCls}-icon`}
                    onClick={playHandle}
                    xmlns="http://www.w3.org/2000/svg"
                    width="100"
                    height="100"
                    viewBox="0 0 100 100"
                    fill="none"
                >
                    <path
                        d="M94.1667 49.8611C94.1667 74.3304 74.3304 94.1667 49.8611 94.1667C25.3918 94.1667 5.55557 74.3304 5.55557 49.8611C5.55557 25.3918 25.3918 5.55557 49.8611 5.55557C74.3304 5.55557 94.1667 25.3918 94.1667 49.8611Z"
                        stroke="white"
                        strokeWidth="2.22222"
                    />
                    <path
                        d="M37.7783 67.9227V34.0886C37.7783 32.3267 39.7308 31.2655 41.2093 32.2239L66.1396 48.3835C67.4577 49.2378 67.4975 51.1526 66.2162 52.0611L41.2858 69.7356C39.8142 70.7789 37.7783 69.7266 37.7783 67.9227Z"
                        fill="white"
                    />
                </svg>
            )}
        </div>
    );
}
